import { ObservableArray, View } from "binder"
import { ColumnVisibilityManipulatorViewModel, SingleColumn } from "./columnVisibilityManipulator-viewModel"

export class ColumnVisibilityManipulatorView extends View<ColumnVisibilityManipulatorViewModel>{
    GetViewUniqueId(): string {
        return "V-21262D72-894F-4ADD-AB50-030E5B811558"
    }
    loadHtml(): string {
        let element = require('./columnVisibilityManipulator.html').default;
        let style = require('./columnVisibilityManipulator.less');
        return element;
    }
    constructor() {
       super();
    }

    public set columns(v: ObservableArray<SingleColumn>) { this._columns = v; } public get columns(): ObservableArray<SingleColumn> { return this._columns;} private _columns: ObservableArray<SingleColumn>;

    confirm(){
        this.dataContext.confirm();
    }
}
